import React, {Fragment, type PropsWithChildren} from 'react';
import type {SxProps} from '@mui/material';
import {Box} from '@mui/material';
import type {IconName} from 'components/icons/types';
import {ColorPalette} from 'theme';
import {Card, FlexBox, Icon, IconButton} from 'components';

type Props = PropsWithChildren & {
  title: string;
  icon: IconName;
  onClose: () => void;
  extraButtons?: React.ReactNode[];
};

const headerSx: SxProps = {
  justifyContent: 'space-between',
};
export const ManifestationPanelContainer: React.FC<Props> = ({
  title,
  icon,
  onClose,
  extraButtons,
  children,
}) => {
  return (
    <Card colorx={ColorPalette.secondary.beige} fillHeight>
      <Card.Header sx={headerSx}>
        <Box>
          {title || icon ? (
            <FlexBox center left horizontal gap={0.5}>
              {icon ? <Icon icon={icon} /> : null}
              {title ? <Box>{title}</Box> : null}
            </FlexBox>
          ) : null}
        </Box>
        <Box>
          {extraButtons?.map((eB, i) => (
            <Fragment key={i}>{eB}</Fragment>
          ))}

          <IconButton icon={'Close'} onClick={onClose} size={'small'} />
        </Box>
      </Card.Header>
      <Card.Content>{children}</Card.Content>
    </Card>
  );
};
